const baseSelector = (state) => state.recordingRequest;

export const RecordingRequestStageSelector = (state) =>
  baseSelector(state).modalStage;

export const RecordingRequestIdSelector = (state) =>
  baseSelector(state).recordingRequest.id;

export const RecordingRequestMetaSelector = (state) =>
  baseSelector(state).recordingRequest.meta;
